import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PauseIcon, PlayIcon, TimerIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { useNow } from '../../hooks/useNow';
import { formatClock, timerElapsedMs } from '../../utils/time';
interface TimerBarProps {
  variant: 'mobile' | 'sidebar';
}
export function TimerBar({
  variant
}: TimerBarProps) {
  const {
    timer,
    activityLabel,
    pauseTimer,
    resumeTimer
  } = useAppState();
  const {
    setTimerSheetOpen
  } = useUi();
  const now = useNow(timer?.status === 'running');
  if (!timer) {
    if (variant === 'mobile') return null;
    return <button type="button" onClick={() => setTimerSheetOpen(true)} className="flex h-11 w-full items-center gap-2 rounded-xl border border-dashed border-line px-3 text-sm font-bold text-muted transition-colors duration-150 hover:border-accent hover:text-accent-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-935" data-mp="2r2tt1b174nro">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-936" data-mp="29u0pfqa84ksy" /> Začni časovnik
      </button>;
  }
  const review = timer.status === 'review';
  const running = timer.status === 'running';
  return <AnimatePresence data-id="element-937" data-mp="1zw35hezeda65">
      <motion.div key={timer.sessionId} initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className={`flex items-center gap-2 rounded-2xl pl-3 pr-1.5 shadow-bar ${review ? 'bg-review-soft text-review-ink' : running ? 'bg-accent text-white' : 'bg-ink text-white'} ${variant === 'mobile' ? 'mx-3 mb-2' : ''}`} data-id="element-938" data-mp="1zwmajv3y842r">
        <button type="button" onClick={() => setTimerSheetOpen(true)} className="flex min-h-[48px] min-w-0 flex-1 items-center gap-2 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-white" aria-label={`Odpri časovnik: ${activityLabel(timer.target)}`} data-id="element-939" data-mp="1h38o6eeax5yr">
          <TimerIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-940" data-mp="12iedw32ct729" />
          <span className="min-w-0 flex-1 truncate text-sm font-bold" data-id="element-941" data-mp="12gjrekbfp6w2">
            {review ? 'Shrani sejo: ' : ''}
            {activityLabel(timer.target)}
          </span>
          <span className="shrink-0 text-sm font-extrabold tabular-nums" data-id="element-942" data-mp="tihuogyqh0el">
            {review ? `${Math.round(timerElapsedMs(timer, now) / 60000)} min` : formatClock(timerElapsedMs(timer, now))}
          </span>
        </button>
        {!review && <button type="button" onClick={running ? pauseTimer : resumeTimer} aria-label={running ? 'Premor' : 'Nadaljuj'} className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-white/15 transition-colors duration-150 hover:bg-white/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white" data-id="element-943" data-mp="17hzaw7xyr5cc">
            {running ? <PauseIcon className="h-4 w-4" fill="currentColor" aria-hidden="true" data-id="element-944" data-mp="2ebey8e47dk7a" /> : <PlayIcon className="h-4 w-4" fill="currentColor" aria-hidden="true" data-id="element-945" data-mp="2ab4vdabpj9wn" />}
          </button>}
      </motion.div>
    </AnimatePresence>;
}